import React from "react";
import NavLink from "../components/NavLink";

const NotFound = () => {
  return (
    <div className=" h-screen mx-auto lg:w-[450px] w-full bg-accent-white-chocolate">
      <div className="flex items-center h-[56px]   rounded-bl-lg rounded-br-lg bg-black "></div>
      <div className="mx-4 px-4 flex justify-start items-center bg-secondary mt-[-23px] h-[43px] rounded-lg">
        <p className="font-poppins font-normal text-base">Not Found</p>
      </div>

      <div className="container">
        <div className="text-center space-y-6 py-20">
          <h1 class="text-4xl font-bold text-accent-silver-900">404</h1>
          <p class="mt-4 text-sm text-accent-silver-900">
            Sorry, the page you are looking for does not exist.
          </p>
          <NavLink intent={"primary"} size={"lg"} label={"Home"} href={"/"} />
        </div>
      </div>
    </div>
  );
};

export default NotFound;
